import "bootstrap/dist/css/bootstrap.min.css";
import BarGraph from "components/graphs/BarGraph";
import React from "react";
import { Card, Col, Row } from "react-bootstrap";

const GNSSServiceAvailabilityCard = ({ innerRef, data }) => {
  const renderGraphs = (constellations) => {
    return constellations.map((constellation, index) => (
      <React.Fragment key={index}>
        {constellation.bands.map((band, index) => (
          <React.Fragment key={index}>
            <p className="text-justify">
              Service availability for {constellation.name} {band.name} (ICAO
              threshold ≥ {band.plots[0].thresholdValues[0]}%)
            </p>
            <Row>
              {band.plots.map((plot, index) => (
                <React.Fragment key={index}>
                  <Col
                    sm={{ span: 12, offset: 0 }}
                    xxl={{ span: 10, offset: 1 }}
                  >
                    <BarGraph width={400} height={400} dataset={plot} />
                  </Col>
                </React.Fragment>
              ))}
            </Row>
          </React.Fragment>
        ))}
      </React.Fragment>
    ));
  };

  return (
    <>
      <Card.Title as="h6" ref={innerRef}>
        Service availability
      </Card.Title>
      <Card.Body>
        <p className="text-justify">
          The service availability represents the percentage of time, over a
          24-hours interval, that the predicted 95% position accuracy is less
          than a specified value
        </p>
        {renderGraphs(data.constellations)}
      </Card.Body>
    </>
  );
};

export default React.memo(
  React.forwardRef((props, ref) => (
    <GNSSServiceAvailabilityCard innerRef={ref} {...props} />
  ))
);
